import { useState } from 'react';
import { Dialog, Box, Typography } from '@mui/material';
import styled from 'styled-components';
import { colors } from '../../../../theme';

//Global Components
import GlobalInput from '../../../../components/global/input';
import GlobalButton from '../../../../components/global/button';
import GlobalDropdown from '../../../../components/global/dropdown';
import { isWhiteSpaceLike } from 'typescript';

//Icons
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

const AddCourse = (props) => {
    const { open, setOpen } = props;

    return (
        <Dialog open={open} maxWidth="sm" fullWidth>
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    padding: '25px 40px 0px 40px',
                    svg: {
                        mr: ' 5px',
                    },
                    h4: {
                        mt: '2px',
                    },
                }}
            >
                <AddButton />
                <Typography variant="h4" sx={{ fontWeight: 700, color: colors.blue.main }}>
                    Add a new Schedule
                </Typography>
            </Box>

            <Box
                sx={{
                    m: '20px 40px',
                }}
            >
                <Box sx={{ display: 'flex', mb: '15px', width: '100%' }}>
                    <InputBox>
                        <span>Subject code</span>
                        <GlobalInput placeholder="e.g. MKTG" type="text" sx={{ mr: '10px' }} />
                    </InputBox>
                    <InputBox>
                        <span>Course Number</span>
                        <GlobalInput placeholder="e.g. 1234" type="number" sx={{ mr: '10px' }} />
                    </InputBox>
                    <InputBox>
                        <span>Title </span>
                        <GlobalInput placeholder="e.g. Digital Asset Design & Integration" type="text" sx={{ width: '300px' }} />
                    </InputBox>
                </Box>
                <Box sx={{ display: 'flex', mb: '15px' }}>
                    <InputBox>
                        <span>Room Number </span>
                        <GlobalInput placeholder="e.g. 810" type="text" sx={{ mr: '10px' }} />
                    </InputBox>
                    <InputBox>
                        <span>Date </span>
                        <GlobalInput placeholder="Jan 10 - Apr 21" type="text" sx={{ mr: '10px' }} />
                    </InputBox>
                    <InputBox>
                        <span>Time </span>
                        <GlobalInput placeholder="e.g. 09:00 AM - 10:30 AM" type="text" />
                    </InputBox>
                </Box>
                <Box sx={{ display: 'flex', mb: '15px' }}>
                    <InputBox>
                        <span>Instructor </span>
                        <GlobalInput placeholder="e.g. Stuart Logie" type="text" sx={{ mr: '10px', width: '360px' }} />
                    </InputBox>
                    <InputBox>
                        <span>Set(optional) </span>
                        <GlobalInput placeholder="e.g. MDDD 4 C" type="text" />
                    </InputBox>
                </Box>
                <Box sx={{ display: 'flex' }}>
                    <InputBox>
                        <span>Number of Weeks</span>
                        <GlobalInput placeholder="e.g. 12" type="text" sx={{ mr: '10px' }} />
                    </InputBox>
                    <InputBox>
                        <span>Days</span>
                        <GlobalInput placeholder="e.g. MDDD 4 C" type="text" sx={{ mr: '10px' }} />
                    </InputBox>
                    <InputBox>
                        <span>Enrol</span>
                        <GlobalInput placeholder="e.g. 25" type="number" />
                    </InputBox>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: ' space-between',
                        m: '25px 0px 10px 0px',
                    }}
                >
                    <GlobalButton
                        variant="outlined"
                        text="cancel"
                        onClick={() => {
                            setOpen(false);
                        }}
                    />
                    <GlobalButton variant="contained" text="Add" />
                </Box>
            </Box>
        </Dialog>
    );
};

export default AddCourse;

const AddButton = styled(AddIcon)`
    background: ${colors.blue.main};
    border-radius: 100%;
    color: white;
    cursor: pointer;
    width: 30px !important;
    height: 30px !important;
`;

const XButton = styled(CloseIcon)`
    background: #f8f8f8;
    color: ${colors.blue.main};
    border-radius: 5px;
    cursor: pointer;
`;

const InputBox = styled.div`
    display: flex;
    flex-direction: column;

    & > span {
        font-size: 12px;
        color: ${colors.grey.dark};
        margin: 0px 0px 2px 0px;
        padding: 0px;
        font-weight: 500;
    }
`;
